import {Injectable} from '@angular/core';
import {EcaConfirmProcessService} from '../shared/services/eca-confirm-process.service';
import {Observable} from 'rxjs';
import {IModalOptions} from '../common/modals/modal-options.interface';

@Injectable({
  providedIn: 'root'
})

export class ErrorHandlingService {
  private errorMessage: string = `An error occurred during the last operation.<p>Please try refreshing the page. If the error persists - please contact ECA.</p> `;
  private ecaConfirmInfoModalOptions: IModalOptions = {
    modalClasses: 'modal-eca-danger',
    noButtonColour:  'transparent',
    noButtonIcon:  ['far', 'times'],
    noButtonText:  'Close',
    yesButtonColour:  '',
    yesButtonIcon:  '',
    yesButtonText:  '',
    editButtonIcon: '',
  }

  constructor(private confirmProcessService: EcaConfirmProcessService) {
  }

  showErrorWarning(message?: string): Observable<any>{
    if(!message){
      message = this.errorMessage ;
    }

    return this.confirmProcessService.openConfirmProcessModal(`<p>${message}</p>`, "Error Warning", this.ecaConfirmInfoModalOptions).asObservable();

  }
}
